module.exports = __webpack_public_path__ + "static/ufo-9b665b04cd605a77d240e6cee6bea7cf.svg";